// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1liQK","logo":"styles-module__logo___3kdPl","subText":"styles-module__subText___2gcbY"};